import React from 'react';
import {
  QUERY_BUILDER_SAVED_QUERY_URL_PATH,
  QUERY_BUILDER_URL_PATH,
} from './paths';

const QueryBuilder = React.lazy(() => import('@/views/QueryBuilder'));
const GetStarted = React.lazy(() => import('@/views/QueryBuilder/GetStarted'));
const QueryContent = React.lazy(
  () => import('@/views/QueryBuilder/QueryContent'),
);

export default {
  path: '/datasources/:datasourceId',
  element: <QueryBuilder />,
  children: [
    {
      index: true,
      element: <GetStarted />,
    },
    {
      path: QUERY_BUILDER_URL_PATH,
      element: <QueryContent />,
    },
    {
      path: QUERY_BUILDER_SAVED_QUERY_URL_PATH,
      element: <QueryContent />,
    },
  ],
};
